import { render, staticRenderFns } from "./footComponent.vue?vue&type=template&id=8d2298a6&scoped=true&"
import script from "./footComponent.vue?vue&type=script&lang=js&"
export * from "./footComponent.vue?vue&type=script&lang=js&"
import style0 from "./footComponent.vue?vue&type=style&index=0&id=8d2298a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2298a6",
  null
  
)

export default component.exports